/**
 * @generated SignedSource<<af88186ec1774d74c1f145b8198ad2ee>>
 * @relayHash f6c6be2638bd276eed3ee9467a28cb6b
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-nft/568.0.0-2026-07-14T15:45:45.033Z/LikeItemMutation

import { ConcreteRequest } from 'relay-runtime';
export type NftItemLikeAction = "ADD" | "REMOVE" | "%future added value";
export type NftItemLikeInput = {
  action: NftItemLikeAction;
  clientMutationId?: string | null;
  itemId: string;
  userId: string;
};
export type LikeItemMutation$variables = {
  input: NftItemLikeInput;
  itemId: string;
  userId: string;
};
export type LikeItemMutation$data = {
  readonly nftItemLike: {
    readonly nftItem: {
      readonly id: string;
      readonly likes: {
        readonly isLikedByUser: boolean | null;
        readonly likeCount: number | null;
      } | null;
    } | null;
    readonly nftItemUserLike: {
      readonly id: string;
      readonly isLiked: boolean | null;
      readonly nftId: string | null;
    } | null;
    readonly viewer: {
      readonly id: string;
      readonly isNftItemLikedByUser: boolean | null;
    };
  } | null;
};
export type LikeItemMutation$rawResponse = {
  readonly nftItemLike: {
    readonly nftItem: {
      readonly id: string;
      readonly likes: {
        readonly isLikedByUser: boolean | null;
        readonly likeCount: number | null;
      } | null;
    } | null;
    readonly nftItemUserLike: {
      readonly id: string;
      readonly isLiked: boolean | null;
      readonly nftId: string | null;
    } | null;
    readonly viewer: {
      readonly id: string;
      readonly isNftItemLikedByUser: boolean | null;
    };
  } | null;
};
export type LikeItemMutation = {
  rawResponse: LikeItemMutation$rawResponse;
  response: LikeItemMutation$data;
  variables: LikeItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "NftItemLikePayload",
    "kind": "LinkedField",
    "name": "nftItemLike",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NftItem",
        "kind": "LinkedField",
        "name": "nftItem",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NftItemLikes",
            "kind": "LinkedField",
            "name": "likes",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "likeCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v4/*:: as any*/)
                ],
                "kind": "ScalarField",
                "name": "isLikedByUser",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NftItemUserLike",
        "kind": "LinkedField",
        "name": "nftItemUserLike",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nftId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isLiked",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "nftId",
                "variableName": "itemId"
              },
              (v4/*:: as any*/)
            ],
            "kind": "ScalarField",
            "name": "isNftItemLikedByUser",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "LikeItemMutation",
    "selections": (v5/*:: as any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v2/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "LikeItemMutation",
    "selections": (v5/*:: as any*/)
  },
  "params": {
    "id": "app-buyer-nft/568.0.0-2026-07-14T15:45:45.033Z/LikeItemMutation",
    "metadata": {},
    "name": "LikeItemMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "32be56512da482be1dd893aab49cbf26";

export default node;
